import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm, isSubmitting} from 'redux-form';

import {PasswordField, TokenField} from 'components/Fields';
import FormField from 'components/FormField';
import Button from 'components/Button';
import ErrorBlock from 'components/ErrorBlock';
import Link from 'components/Link';
import {ROUTER_LOGIN_URL} from 'config/urls';

import {
  selectForgotPasswordSetErrors,
  selectForgotPasswordSetSuccess,
  selectForgotPasswordSetToken,
  adminForgotPasswordSet
} from 'ducks/auth';

import './styles.css';

const formSubmit = (values, dispatch) => {
  const {token, password} = values;

  dispatch(adminForgotPasswordSet({token, password}));
};

class ForgotPasswordSetForm extends React.Component<any> {
  render() {
    const {submitting, handleSubmit, errors, success} = this.props;
    const submitDisabled = submitting || success || !_.isNil(errors);
    return (
      <form className="ForgotPasswordSetForm" onSubmit={handleSubmit}>
        {errors && <ErrorBlock>{errors}</ErrorBlock>}
        {success && (
          <div className="formPasswordSetText success">
            <p>Password successfuly changed!</p>
            <p>
              You can now <Link to={ROUTER_LOGIN_URL}>Login →</Link>
            </p>
          </div>
        )}
        <FormField>
          <Field
            component={TokenField}
            placeholder="Token"
            name="token"
            disabled={true}
          />
        </FormField>
        <FormField>
          <Field
            component={PasswordField}
            placeholder="Password"
            name="password"
            disabled={submitDisabled}
          />
        </FormField>
        <FormField>
          <Button disabled={submitDisabled}>Reset password</Button>
        </FormField>
      </form>
    );
  }
}

const mapStateToProps = state => {
  return {
    initialValues: {
      token: selectForgotPasswordSetToken(state)
    },
    submitting: isSubmitting('forgotPasswordSet')(state),
    errors: selectForgotPasswordSetErrors(state),
    success: selectForgotPasswordSetSuccess(state)
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'forgotPasswordSet',
    onSubmit: formSubmit,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
  })(ForgotPasswordSetForm)
);
